import Vue from "vue";
import VS2 from "vue-script2";
import Ads from "vue-google-adsense";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

Vue.use(VS2);

Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);
Vue.use(Ads.InFeedAdsense);
/*Vue.use(Ads.AutoAdsense, {
  adClient: "ca-pub-1486093574542110",
  isNewAdsCode: true
});*/

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
